import { render, staticRenderFns } from "./user-selector-dialog.vue?vue&type=template&id=41be6a61&scoped=true"
import script from "./user-selector-dialog.vue?vue&type=script&lang=js"
export * from "./user-selector-dialog.vue?vue&type=script&lang=js"
import style0 from "./user-selector-dialog.vue?vue&type=style&index=0&id=41be6a61&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41be6a61",
  null
  
)

export default component.exports